module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot4-65109f2048ec03cc1bbdf3399dbfe637.png";